import { PlayerMinimized } from '../api-types';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import { useCallback } from 'react';
import adminApi from '../../../../api/admin-api';
import { useUserAuth } from '../../../../contexts/auth';

export const useTeam = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { strings } = useStringsContext();
  const { currentUser } = useUserAuth();

  const fetchTeam = useCallback(
    async (teamId: string, season: number): Promise<PlayerMinimized[] | null | undefined> => {
      let data: PlayerMinimized[] | null = null;

      try {
        const response = await adminApi.get({
          path: `/players/fogis/${teamId}/${season}`,
          auth: await currentUser?.getIdToken(),
        });

        if (!response.ok) {
          throw new Error(`Fetching team failed! (${response.status})`);
        }

        data = await response.json();
      } catch (error) {
        console.error(error);

        enqueueSnackbar(strings.messages.loadingError, {
          variant: 'error',
        });
        throw error;
      }

      return data;
    },
    [enqueueSnackbar, strings, currentUser]
  );

  return { fetchTeam };
};
